export const IntegrationProcess = 'VerificationAgency/IntegrationProcess';

export const Submissions = `${IntegrationProcess}/Submissions`;
export const SearchSubmissions = `${Submissions}/Search`;
export const HasPendingSubmission = `${Submissions}/HasPendingSubmission`;
export const HasAnyPendingSubmission = `${Submissions}/HasAnyPendingSubmission`;
export const GetSubmissionDetails = `${Submissions}/GetSubmissionDetails`;
export const ProcessSubmission = `${Submissions}/Process`;

export const scorecard2013 = `VA/IntegrationProcess`;
export const SubmitScorecard = `${scorecard2013}/Submit`;
export const CopyProgress = `${scorecard2013}/CopyProgress`;
export const RemoveKey = `${scorecard2013}/RemoveKey`;